import { createAction } from '@reduxjs/toolkit';

export const setQueryClientAction = createAction<any>(
  '@@core/SET_QUERY_CLIENT_SAGA',
);

export const setFeatureFlagAction = createAction<any>(
  '@@core/SET_FEATURE_FLAG',
);
